import axios from "axios";
import history from "~/routes/history";
import { store } from "~/store";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";

const apiJson = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    "Content-Type": "application/json",
  },
});

apiJson.interceptors.request.use(
  function(config) {
    config.data.append("Idioma", 2);
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

apiJson.interceptors.response.use(
  (response) => {
    if (response.data.forceLogout) {
      const { dispatch } = store;
      dispatch(AuthenticationActions.purgeAuthentication());
      history.push("/login");
    }
    return response;
  },
  (error) => {
    return error;
  }
);

export default apiJson;
